import { Pipe, PipeTransform } from '@angular/core';
import { QuizStatus } from '../models/quiz.model';

@Pipe({
  name: 'quizStatusLabel',
  standalone: true,
})
export class QuizStatusPipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case QuizStatus.draft:
        return 'Draft';
      case QuizStatus.waiting:
        return 'Waiting';
      case QuizStatus.inProgress:
        return 'In Progress';
      case QuizStatus.completed:
        return 'Completed';
      case QuizStatus.scheduled:
        return 'Scheduled';
      case QuizStatus.cancelled:
        return 'Cancelled';
      default:
        return value;
    }
  }
}
